import {IMatch} from "data/types/entities";
import {isNumber} from "lodash";

export abstract class SquadUtils {
	static SELECTED_SQUAD = SquadUtils.selectedSquadID();

	static selectedSquadID() {
		const squadID = new URLSearchParams(window.location.search).get("squadID");
		const value = Number(squadID);
		if (!squadID || !isNumber(value)) {
			return null;
		}
		return value;
	}

	static filterBySquadID = (match: IMatch) => {
		if (!SquadUtils.SELECTED_SQUAD) {
			return true;
		}

		return [match.homeSquad.id, match.awaySquad.id].includes(SquadUtils.SELECTED_SQUAD);
	};
}
